export default "__VITE_ASSET__a9077429__"